import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import React from "react";
import styles from "./BackgroundBubbles.module.scss";
import { ReactSVG } from "react-svg";

interface BackgroundBubblesProps {
  topLeft?: boolean;
  topRight?: boolean;
  bottomLeft?: boolean;
  colorBubbles?: string;
}

function BackgroundBubbles({
  topLeft = true,
  topRight = true,
  bottomLeft = true,
  colorBubbles = "var(--pistachio",
}: BackgroundBubblesProps) {
  const { getIcon } = useGlobalContext();

  // ReactSVG cannot use correct ID of mask, we have to update it manually for the gElement.
  // Otherwise mask is not displayed properly
  const beforeInjection = (svg: SVGSVGElement): void => {
    const maskElement = svg.querySelector("mask");
    const gElement = svg.querySelector("g[mask]");

    if (maskElement && gElement) {
      const originalMaskId = maskElement.id;
      gElement.setAttribute("mask", `url(#${originalMaskId})`);
    }

    const paths = svg.querySelectorAll("g path");
    paths.forEach((path) => {
      path.setAttribute("fill", colorBubbles);
    });
  };

  return (
    <>
      {topLeft && (
        <div
          className={`bubbles-upper-left ${styles["bubbles-upper-left"]}`}
          aria-hidden
        >
          <ReactSVG
            width={96}
            height={82}
            src={getIcon("bubbles-top-left")}
            beforeInjection={beforeInjection}
          />
        </div>
      )}

      {topRight && (
        <div
          className={`bubbles-upper-right ${styles["bubbles-upper-right"]}`}
          aria-hidden
        >
          <ReactSVG
            height={68}
            width={85}
            src={getIcon("bubbles-top-right")}
            beforeInjection={beforeInjection}
          />
        </div>
      )}

      {bottomLeft && (
        <div
          className={`bubbles-lower-left ${styles["bubbles-lower-left"]}`}
          aria-hidden
        >
          <ReactSVG
            width={96}
            height={82}
            src={getIcon("bubbles-bottom-left")}
            beforeInjection={beforeInjection}
          />
        </div>
      )}
    </>
  );
}

export default BackgroundBubbles;
